import styled from 'styled-components'
import Button from '@shared/Form/Button'
import Modal from '@shared/Modal'
import i18n from 'i18next'

type Props = {
  content: string
  okText?: string
  cancelText?: string
  onOk: () => void
  onCancel: () => void
}

function ConfirmModal({
  content,
  okText = i18n.t('common:ok'),
  cancelText = i18n.t('common:cancel'),
  onOk,
  onCancel
}: Props) {
  return (
    <StyledModal
      className="test"
      width="400px"
      open
      onCancel={onCancel}
      footer={[
        <Button
          key="ok"
          size="small"
          style={{ minWidth: 96, marginRight: 8 }}
          type="danger"
          onClick={onOk}>
          <span style={{ letterSpacing: 6, textIndent: 6 }}>{okText}</span>
        </Button>,
        <Button
          key="cancel"
          size="small"
          type="primary"
          style={{ minWidth: 96 }}
          onClick={onCancel}>
          <span style={{ letterSpacing: 6, textIndent: 6 }}>{cancelText}</span>
        </Button>,
      ]}>
      {content}
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    .ant-modal-close {
      padding: 16px;
      display: block;
      position: inherit;
      float: right;
      .ant-modal-close-x {
        width: 32px;
        height: 32px;
        line-height: 25px;
        font-size: 23px;
      }
    }
    .ant-modal-body {
      clear: both;
      text-align: center;
      font-size: 15px;
      font-weight: 500;
      padding: 16px;
      margin-bottom: 23px;
    }
  }
  .ant-modal-footer {
    padding: 24px 32px;
    border: 0;
  }
`

const StyledButton = styled(Button)`
  padding: 5px 8px;
  min-width: 80px !important;
  line-height: initial !important;
`

export default ConfirmModal
